import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { AppKitNetwork } from "@reown/appkit/networks";
import { createAppKit } from "@reown/appkit/react";

import { mainnetChain } from "shared/config/const";

const networks: [AppKitNetwork, ...AppKitNetwork[]] = [
  mainnetChain,
  // mainnet,
  // mainnet,
  // sepolia,
  // mainnetChain,
];

const projectId = "47daa50416effcf4b1f3d7bc76013da9";

const metadata = {
  name: "Bento pre-deposit",
  description: "Bento pre-deposit",
  url: "https://bento-app-fe.pages.dev",
  icons: ["https://avatars.githubusercontent.com/u/179229932"],
};

const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
  ssr: false,
});

createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  defaultNetwork: mainnetChain,
  debug: true,
  allowUnsupportedChain: true,
  metadata,
  features: {
    socials: false,
    email: false,
    analytics: false, // Optional - defaults to your Cloud configuration
  },
});

export const config = wagmiAdapter.wagmiConfig;
